var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01118 1.80156C6.34188 1.23867 7.1558 1.23867 7.48651 1.80156L8.723 3.90618C8.84437 4.11277 9.04682 4.259 9.28109 4.30929L11.6706 4.82228C12.314 4.96039 12.5671 5.74277 12.1266 6.23156L10.5055 8.03021C10.3436 8.20978 10.2653 8.44944 10.2898 8.68993L10.5357 11.0969C10.6022 11.7483 9.94211 12.23 9.34204 11.9678L7.09135 10.9846C6.87298 10.8892 6.62471 10.8892 6.40634 10.9846L4.15565 11.9678C3.55558 12.23 2.89548 11.7483 2.96201 11.0969L3.20784 8.68993C3.2324 8.44944 3.15408 8.20978 2.99223 8.03021L1.37113 6.23156C0.930584 5.74277 1.18371 4.96039 1.82707 4.82228L4.2166 4.30929C4.45087 4.259 4.65331 4.11277 4.77469 3.90618L6.01118 1.80156Z",
    fill: "url(#paint0_linear_8502_47897)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8502_47897",
    x1: 6.74891,
    y1: 1.45562,
    x2: 6.74891,
    y2: 12.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.fb6d53c6a2749e1830337900da17ec0a.svg";
export { ForwardRef as ReactComponent };